import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import { Get_One_From_MongoDB } from "../../../api/Get_One_From_MongoDB";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import "./ViewSEFReview.css"; // Import the CSS file
import { Arr_SEFPages } from "../../../../arrays/SEF/Arr_SEFPages";
import { Update_To_MongoDB_By_ID_No_Alert } from "../../../api/Update_To_MongoDB_By_ID_No_Alert";
import getPhotoGroup from "../../../../functions/getPhotoGroup";
import { Get_One_From_MongoDB_No_Alerts } from "../../../api/Get_One_From_MongoDB_No_Alerts";
import { Get_One_From_MongoDB_Filter_No_Alerts } from "../../../api/Get_One_From_MongoDB_Filter_No_Alerts";
import { Get_limited_Choose_Fields_With_Sort_From_MongoDB } from "../../../api/Get_limited_Choose_Fields_With_Sort_From_MongoDB";
import getNameByID from "../../../../functions/getNameByID";
import SEFMassStage from "./components/SEFMassStage";
import SEFIntro from "./components/SEFIntro";
import SEFNotes from "./components/SEFNotes";
import SEFEmail from "./components/SEFEmail";
import SEFText from "./components/SEFText";
import YYYYMMDDtoDDMMYYYY from "../../../../functions/YYYYMMDDtoDDMMYYYY";
import getAge from "../../../../functions/getAge";
import { Post_Question_To_CurtAI_Medical_Overview } from "../../CurtAI/api/Post_Question_To_CurtAI_Medical_Overview";
import { Post_Question_To_CurtAI_Medical_Overview_State } from "../../CurtAI/api/Post_Question_To_CurtAI_Medical_Overview_State";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";

const ViewSEFReview = () => {
  const { id } = useParams();
  const { logout } = StaffuseAuth();

  // Assuming Attendee state is fetched from an API using the id
  const [Attendee, setAttendee] = useState({
    _id: id,
  });

  useEffect(() => {
    if (id !== "AddAttendee") {
      Get_One_From_MongoDB("Registers_2025", "All", id, setAttendee, logout);
    }
  }, []);

  //The below gets the staff
  const [Staff, setStaff] = useState([]);
  useEffect(() => {
    Get_limited_Choose_Fields_With_Sort_From_MongoDB(
      "Staff",
      "Users",
      100,
      { Username: 1 },
      setStaff,
      {
        Username: 1,
        Team: 1,
        Level: 1,
        _id: 1,
      },
      logout
    );
  }, []);

  ///////////////////////////////////////////////////
  //get all photo data

  const [ID_Image_Front_2025, setID_Image_Front_2025] = useState({
    myFile: "",
  });
  const [ID_Image_Back_2025, setID_Image_Back_2025] = useState({ myFile: "" });
  const [Clear_Image_2025, setClear_Image_2025] = useState({ myFile: "" });
  const [Language_Image_2025, setLanguage_Image_2025] = useState({
    myFile: "",
  });

  useEffect(() => {
    Get_One_From_MongoDB_Filter_No_Alerts(
      "ID_Image_Front_2025",
      getPhotoGroup(id.slice(-1)),
      { Attendee_ID: id },
      setID_Image_Front_2025,
      logout
    );
    Get_One_From_MongoDB_Filter_No_Alerts(
      "ID_Image_Back_2025",
      getPhotoGroup(id.slice(-1)),
      { Attendee_ID: id },
      setID_Image_Back_2025,
      logout
    );
    Get_One_From_MongoDB_Filter_No_Alerts(
      "Clear_Image_2025",
      getPhotoGroup(id.slice(-1)),
      { Attendee_ID: id },
      setClear_Image_2025,
      logout
    );
    Get_One_From_MongoDB_Filter_No_Alerts(
      "Language_Image_2025",
      getPhotoGroup(id.slice(-1)),
      { Attendee_ID: id },
      setLanguage_Image_2025,
      logout
    );
  }, []);
  ///////////////////////////////////////////////////
  //Where the boxes are made and the buttons are operated
  function handleUpdateOneSEFPageProgress(e, MongoDB, Value) {
    e.preventDefault();
    const newAttendee = { ...Attendee };
    newAttendee.SEFProgress = {
      ...newAttendee.SEFProgress,
      [MongoDB]: Value,
    };
    setAttendee(newAttendee);
    let updateString = "SEFProgress" + "." + MongoDB;
    console.log(updateString);
    Update_To_MongoDB_By_ID_No_Alert(
      { [updateString]: Value },
      "Registers_2025",
      "All",
      id,
      logout
    );
  }

  ////////////////////////////////////////////////////
  //Age Calc

  //Get Length
  let str_Length;
  if (Attendee.BasicInfo?.ProgrammeVarient.toLowerCase().includes("1 week")) {
    str_Length = "1 Week";
  } else if (
    Attendee.BasicInfo?.ProgrammeVarient.toLowerCase().includes("premium")
  ) {
    str_Length = "2 Weeks";
  } else if (
    Attendee.BasicInfo?.ProgrammeVarient.toLowerCase().includes("2 week") ||
    Attendee.BasicInfo?.ProgrammeVarient.toLowerCase().includes("2 - week") ||
    Attendee.BasicInfo?.ProgrammeVarient.toLowerCase().includes("2-week")
  ) {
    str_Length = "2 Weeks";
  } else {
    str_Length = "TBC";
  }
  //Get Dates

  let str_StartDate;
  let str_EndDate;
  if (Attendee.BasicInfo?.ProgrammeDate.toLowerCase().includes("18th aug")) {
    str_StartDate = "2025-08-18";
  } else if (
    Attendee.BasicInfo?.ProgrammeDate.toLowerCase().includes("28th july")
  ) {
    str_StartDate = "2025-07-28";
  } else if (
    Attendee.BasicInfo?.ProgrammeDate.toLowerCase().includes("7th july")
  ) {
    str_StartDate = "2025-07-07";
  } else {
    str_StartDate = "TBC";
  }
  //get str_EndDate as str_StartDate + str_Length
  if (str_StartDate === "2025-08-18") {
    //
    if (str_Length === "1 Week") {
      str_EndDate = "2025-08-22";
    } else if (str_Length === "2 Weeks") {
      str_EndDate = "2025-08-29";
    } else {
      str_EndDate = "TBC";
    }

    //
  } else if (str_StartDate === "2025-07-28") {
    //
    if (str_Length === "1 Week") {
      str_EndDate = "2025-07-28";
    } else if (str_Length === "2 Weeks") {
      str_EndDate = "2025-07-28";
    } else {
      str_EndDate = "TBC";
    }
    //
  } else if (str_StartDate === "2025-07-07") {
    //
    if (str_Length === "1 Week") {
      str_EndDate = "2025-07-11";
    } else if (str_Length === "2 Weeks") {
      str_EndDate = "2025-07-18";
    } else {
      str_EndDate = "TBC";
    }
    //
  } else {
    str_EndDate = "TBC";
  }

  ///////////////////////////////////////////////////////

  //--------------------CurtAI

  const [CurtAI_text, setCurtAI_text] = useState("");
  const [startCurtAI, setstartCurtAI] = useState(false);
  const [startedCurtAI, setstartedCurtAI] = useState(false);

  function handlestartCurtAI(e) {
    e.preventDefault();
    setstartCurtAI(true);
  }

  function getCurtAI() {
    let allMedicalFields = Arr_SEFPages.filter(
      (Obj_SEFPage) => Obj_SEFPage.Medical === "Yes"
    );
    allMedicalFields = allMedicalFields.map((Obj_SEFPage) => {
      return Obj_SEFPage.MongoDB;
    });
    let newMedicalFields = Object.keys(Attendee).reduce((acc, key) => {
      if (allMedicalFields.includes(key)) {
        acc[key] = Attendee[key];
      }
      return acc;
    }, {});
    let newMedicalFieldsString = Object.entries(newMedicalFields)
      .map(([key, value]) => {
        if (typeof value === "object") {
          return `${Object.entries(value)
            .filter(([key2, value2]) => value2 !== "No")
            .map(([key2, value2]) => `${key2}: ${value2}`)
            .join(", ")}`;
        } else {
          return `${key}: ${value}`;
        }
      })
      .join(", ");
    Post_Question_To_CurtAI_Medical_Overview_State(
      newMedicalFieldsString,
      setCurtAI_text,
      logout
    );
  }

  useEffect(() => {
    if (startCurtAI && !startedCurtAI) {
      setstartedCurtAI(true);
      getCurtAI();
    } else {
    }
  }, [startCurtAI]);
  console.log("CurtAI_text");
  console.log(CurtAI_text);

  ////////////////////////////////////////

  const [status, setStatus] = useState(false);
  function handleShowMedicalAccessQuestions(e) {
    e.preventDefault();
    Update_To_MongoDB_By_ID(
      { "SEFInfo.ShowMedicalAccessQuestions": "Yes" },
      "Registers_2025",
      "All",
      setStatus,
      Attendee._id,
      logout
    );
  }
  ////////////////////////////////////////

  let CurtAI_Div = startCurtAI ? (
    CurtAI_text && CurtAI_text[0] ? (
      <div key={"index"} className={""}>
        <h3 style={{ marginTop: "0px" }}>
          CurtAI
          <br></br>
        </h3>
        <div style={{ fontSize: "1.2em" }}>
          <div key={"index"}>
            <p>
              <b>Medical Overview: </b>
              <div
                dangerouslySetInnerHTML={{
                  __html: CurtAI_text[0]
                    .split("\n\n")
                    .map(
                      (paragraph) =>
                        `<p>${paragraph.replace(/\n/g, "<br>")}</p>`
                    )
                    .join(""),
                }}
              />
            </p>
          </div>
        </div>
      </div>
    ) : (
      <div key={"index"} className={""}>
        <h3 style={{ marginTop: "0px" }}>
          Loading...
          <br></br>
        </h3>
      </div>
    )
  ) : (
    <div key={"index"} className={""}>
      <h3 style={{ marginTop: "0px" }}>
        Get CurtAI Overview
        <br></br>
      </h3>
      <div style={{ fontSize: "1.2em" }}>
        <div key={"index"}>
          {Attendee.SEFInfo && (
            <button onClick={(e) => handlestartCurtAI(e)}>
              Get CurtAI Overview
            </button>
          )}
        </div>
      </div>
    </div>
  );

  ///////////////////////////////////////////////////

  const columns = [[CurtAI_Div], [], [], []];

  Arr_SEFPages.forEach((Obj_SEFPage, index) => {
    columns[Obj_SEFPage.Column - 1].push(
      <div
        key={index}
        className={
          Attendee.SEFProgress?.[Obj_SEFPage.Prop]
            ? Attendee.SEFProgress?.[Obj_SEFPage.Prop] + "_box"
            : "box"
        }
      >
        <h3 style={{ marginTop: "0px" }}>
          {Obj_SEFPage.label}
          <br></br>
          {Attendee.SEFProgress?.[Obj_SEFPage.Prop]?.replace("_", " ")}
        </h3>

        {Obj_SEFPage.MongoDB === "Contacts" ? (
          <div style={{ fontSize: "1.2em" }}>
            {Attendee.Contacts && Attendee.Contacts?.length > 0 ? (
              Attendee.Contacts?.map((contact, index) => (
                <div key={index}>
                  <p>
                    <b>{contact.Person}: </b>
                    {contact.Email} <b>Active: </b>
                    {contact.Active}
                  </p>
                </div>
              ))
            ) : (
              <></>
            )}
          </div>
        ) : (
          <></>
        )}
        {Obj_SEFPage.MongoDB === "Photos" ? (
          <div style={{ fontSize: "1.2em" }}>
            <p>{ID_Image_Front_2025.Photo_Type}</p>
            <a href={ID_Image_Front_2025.myFile} target="_blank">
              <img
                src={ID_Image_Front_2025.myFile}
                alt=""
                style={{ maxWidth: "100%", maxHeight: "100%" }}
                onClick={(e) => window.open(ID_Image_Front_2025.myFile)}
              ></img>
            </a>
            <p>{ID_Image_Back_2025.Photo_Type}</p>
            <img
              src={ID_Image_Back_2025.myFile}
              alt=""
              style={{ maxWidth: "100%", maxHeight: "100%" }}
            ></img>
            <p>{Clear_Image_2025.Photo_Type}</p>
            <img
              src={Clear_Image_2025.myFile}
              alt=""
              style={{ maxWidth: "100%", maxHeight: "100%" }}
            ></img>{" "}
            <p>{Language_Image_2025.Photo_Type}</p>
            <img
              src={Language_Image_2025.myFile}
              alt=""
              style={{ maxWidth: "100%", maxHeight: "100%" }}
            ></img>{" "}
          </div>
        ) : (
          <></>
        )}
        {Obj_SEFPage.MongoDB === "SEFGeneralInfo" ? (
          <>
            <p>
              {Attendee[Obj_SEFPage.MongoDB] &&
              typeof Attendee[Obj_SEFPage.MongoDB] === "object" ? (
                <>
                  <p>
                    {Object.entries(Attendee?.[Obj_SEFPage.MongoDB]).map(
                      ([key, value]) => (
                        <div style={{ fontSize: "1.2em" }}>
                          {key.replaceAll("_", " ")}:{" "}
                          <b
                            style={
                              value === "Red"
                                ? {
                                    border: "1px solid #D11212",
                                    color: "#D11212",
                                  }
                                : value === "Blue"
                                ? {
                                    border: "1px solid #0853B6",
                                    color: "#0853B6",
                                  }
                                : value === "Amber"
                                ? {
                                    border: "1px solid #F98007",
                                    color: "#F98007",
                                  }
                                : value === "Green"
                                ? {
                                    border: "1px solid #06862F",
                                    color: "#06862F",
                                  }
                                : {}
                            }
                          >
                            {value.includes("-") && value.length === 10
                              ? YYYYMMDDtoDDMMYYYY(value)
                              : value}
                          </b>
                          <br></br>
                        </div>
                      )
                    )}
                  </p>
                  <h3 style={{ width: "100%", textAlign: "center" }}>
                    <i>
                      <u>Medical & Declaration Access</u>
                    </i>
                  </h3>
                  {Attendee.SEFInfo ? (
                    <p>
                      {Object.entries(Attendee?.SEFInfo).map(([key, value]) =>
                        key === "SEF" ||
                        key === "SEFSubmissionDate" ||
                        key === "Staff_Assigned" ||
                        key === "MedicalOverview" ||
                        key === "staffOverrideMedicalAccess" ? (
                          <></>
                        ) : (
                          <div style={{ fontSize: "1.2em" }}>
                            {key.replaceAll("_", " ")}:{" "}
                            <b
                              style={
                                value === "Red"
                                  ? {
                                      border: "1px solid #D11212",
                                      color: "#D11212",
                                    }
                                  : value === "Blue"
                                  ? {
                                      border: "1px solid #0853B6",
                                      color: "#0853B6",
                                    }
                                  : value === "Amber"
                                  ? {
                                      border: "1px solid #F98007",
                                      color: "#F98007",
                                    }
                                  : value === "Green"
                                  ? {
                                      border: "1px solid #06862F",
                                      color: "#06862F",
                                    }
                                  : {}
                              }
                            >
                              {value.includes("-") && value.length === 10
                                ? YYYYMMDDtoDDMMYYYY(value)
                                : value}
                            </b>
                            <br></br>
                          </div>
                        )
                      )}
                      <br></br>
                      {Attendee.SEFInfo?.ShowMedicalAccessQuestions ===
                      "Yes" ? (
                        <></>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-around",
                          }}
                        >
                          <button
                            style={{ width: "50%" }}
                            onClick={(e) => handleShowMedicalAccessQuestions(e)}
                          >
                            Show Above Q's on SEF
                          </button>
                        </div>
                      )}
                    </p>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>Empty</>
              )}
            </p>
          </>
        ) : (
          <></>
        )}

        {Obj_SEFPage.MongoDB !== "Contacts" &&
        Obj_SEFPage.MongoDB !== "Photos" &&
        Obj_SEFPage.MongoDB !== "SEFGeneralInfo" ? (
          <>
            <p>
              {Attendee[Obj_SEFPage.MongoDB] &&
              typeof Attendee[Obj_SEFPage.MongoDB] === "object" ? (
                <>
                  <p>
                    {Object.entries(Attendee?.[Obj_SEFPage.MongoDB]).map(
                      ([key, value]) => (
                        <div style={{ fontSize: "1.2em" }}>
                          {key.replaceAll("_", " ")}:{" "}
                          <b
                            style={
                              value === "Red"
                                ? {
                                    border: "1px solid #D11212",
                                    color: "#D11212",
                                  }
                                : value === "Blue"
                                ? {
                                    border: "1px solid #0853B6",
                                    color: "#0853B6",
                                  }
                                : value === "Amber"
                                ? {
                                    border: "1px solid #F98007",
                                    color: "#F98007",
                                  }
                                : value === "Green"
                                ? {
                                    border: "1px solid #06862F",
                                    color: "#06862F",
                                  }
                                : {}
                            }
                          >
                            {value.includes("-") && value.length === 10
                              ? YYYYMMDDtoDDMMYYYY(value)
                              : value}

                            {key === "DOB" ? (
                              <>
                                <br></br>
                                Age:
                                <br></br>
                                <div
                                  style={{
                                    color:
                                      getAge(value, str_StartDate) > 18 ||
                                      getAge(value, str_StartDate) < 15
                                        ? "red"
                                        : getAge(value, str_StartDate) == 14 ||
                                          getAge(value, str_StartDate) == 18
                                        ? "orange"
                                        : "black",
                                  }}
                                >
                                  Start of Programme:{" "}
                                  {getAge(value, str_StartDate)}
                                </div>
                                <div
                                  style={{
                                    color:
                                      getAge(value, str_EndDate) > 18 ||
                                      getAge(value, str_EndDate) < 15
                                        ? "red"
                                        : getAge(value, str_EndDate) == 14 ||
                                          getAge(value, str_EndDate) == 18
                                        ? "orange"
                                        : "black",
                                  }}
                                >
                                  End of Programme: {getAge(value, str_EndDate)}
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                          </b>
                          <br></br>
                        </div>
                      )
                    )}
                  </p>
                </>
              ) : (
                <>Empty</>
              )}
            </p>
          </>
        ) : (
          <></>
        )}
        <br></br>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {/* <button
            style={{ width: "23%", backgroundColor: "#f44336" }}
            onClick={(e) =>
              handleUpdateOneSEFPageProgress(e, Obj_SEFPage.Prop, "Incomplete")
            }
          >
            Incomplete
          </button> */}
          <button
            style={{ width: "23%", backgroundColor: "#0853B6" }}
            onClick={(e) =>
              handleUpdateOneSEFPageProgress(e, Obj_SEFPage.Prop, "In_Progress")
            }
          >
            In Progress
          </button>
          <button
            style={{ width: "23%", backgroundColor: "#F98007" }}
            onClick={(e) =>
              handleUpdateOneSEFPageProgress(
                e,
                Obj_SEFPage.Prop,
                "Awaiting_Review"
              )
            }
          >
            Awaiting Review
          </button>
          <button
            style={{ width: "23%", backgroundColor: "#06862F" }}
            onClick={(e) =>
              handleUpdateOneSEFPageProgress(e, Obj_SEFPage.Prop, "Complete")
            }
          >
            Complete
          </button>
        </div>
      </div>
    );
  });

  /////////////////////////////////////////////////

  return (
    <div>
      <div className="header">
        <div className="header-section-5">
          <SEFText Attendee={Attendee} />
        </div>
        <div className="header-section">
          <SEFIntro Attendee={Attendee} />
        </div>
        <div className="header-section-2">
          <SEFMassStage
            Attendee={Attendee}
            setAttendee={setAttendee}
            id={id}
            logout={logout}
          />
        </div>
        <div className="header-section-3">
          <SEFEmail
            Attendee={Attendee}
            setAttendee={setAttendee}
            id={id}
            logout={logout}
          />
        </div>
        <div className="header-section-4">
          <SEFNotes
            Attendee={Attendee}
            Staff={Staff}
            setAttendee={setAttendee}
          />
        </div>
      </div>
      <div className="primaryContainer">
        {columns.map((column, index) => (
          <div key={index} className="secondaryContainer">
            {column}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ViewSEFReview;
